module.exports = __webpack_public_path__ + "static/media/julia_r.0dfbee76.jpg";